import { http } from "./api";

const loadSnap = (src, clientKey) =>
  new Promise((resolve, reject) => {
    if (window.snap) return resolve();
    const s = document.createElement("script");
    s.src = src;
    s.setAttribute("data-client-key", clientKey);
    s.onload = () => resolve();
    s.onerror = () => reject(new Error("Gagal memuat Midtrans"));
    document.head.appendChild(s);
  });

export async function payBooking({ code, email, method, onDone }) {
  const { data } = await http.post("/payments/start", {
    code, email, method, origin_url: window.location.origin,
  });
  if (data.type === "demo") {
    await http.post("/payments/demo/complete", { code, email });
    return onDone();
  }
  if (data.type === "redirect") {
    window.location.href = data.url;
    return;
  }
  if (data.type === "snap") {
    await loadSnap(data.snap_js, data.client_key);
    window.snap.pay(data.token, { onSuccess: onDone, onPending: onDone, onError: onDone, onClose: onDone });
  }
}
